<template lang="pug">
Loading(v-if="!loaded" v-show="initialFail")
.sm(v-else)
	.sm-table.sm-table--local
		.ge-head_team
			img.ge-head_team__img(:src="$store.state.match.localImage", :alt="$store.state.match.localShortName")
			span.ge-head_team__name {{ $store.state.match.localShortName }}
		.ge-btn(
			:class="isLocalTeamSelected ? 'ge-btn' : 'ge-btn--ghost'"
			role="button"
			@click="toggleLocalTeam"
		)
			span {{ $t('Select all') }}
		table.ta.ta--sm(v-show="!userRequestFail")
			thead.ta-section.ta-section--head
				tr.ta-row
					th.ta-col {{ $t('Num.') }}
					th.ta-col.ta-col--name {{ $t('Player') }}
					th.ta-col {{ $t('Pun') }}
			tbody.ta-section.ta-section--body
				tr.ta-row(
					role="button"
					v-for="(player, name) in shots.local_team"
					:id="name"
					@click="toggleLocalPlayer(player,sel_local_players)"
					:class="isLocalPlayerSelected(player) ? 'ta-row--selected' : ''"
				)
					td.ta-col 
						span {{ player.num }}
					td.ta-col.ta-col--name 
						span {{ name }}
					td.ta-col
						span {{ player.score }}
								
	.sm-gra-wrap
		.sm-gra-fi
			.fi-per-wrap
				span.fi-per__label {{ $t('Shots') }}
				.fi-per
					.fi-per__item(
						@click="setStatus('all')"
						:class="{'fi-per__item--selected': isShowAll}"
					)
						span {{ $t('All') }}
					.fi-per__item(
						@click="setStatus('scored')"
						:class="{'fi-per__item--selected': isShowScored}"
					)
						span {{ $t('Scored') }}
					.fi-per__item(
						@click="setStatus('miss')"
						:class="{'fi-per__item--selected': isShowMiss}"
					)
						span {{ $t('Miss') }}
			NavQuarter

		Loading(v-if="userRequestFail")
		.sm-gra(v-else)
			svg(viewBox="0 0 513 294")
				defs
					path#out(transform="scale(0.8 0.8)" d='M7.81832 5.66919L11.0417 8.89258C11.4373 9.28813 11.4373 9.92946 11.0417 10.3253L10.3253 11.0417C9.92977 11.4373 9.28844 11.4373 8.89257 11.0417L5.66918 7.81833L2.4458 11.0417C2.05025 11.4373 1.40892 11.4373 1.01304 11.0417L0.296666 10.3253C-0.0988886 9.92978 -0.0988886 9.28845 0.296666 8.89258L3.52005 5.66919L0.296666 2.44581C-0.0988886 2.05026 -0.0988886 1.40893 0.296666 1.01306L1.01304 0.296676C1.4086 -0.0988789 2.05025 -0.0988789 2.4458 0.296676L5.66918 3.52006L8.89257 0.296676C9.28812 -0.0988789 9.92977 -0.0988789 10.3253 0.296676L11.0417 1.01306C11.4373 1.40861 11.4373 2.04994 11.0417 2.44581L7.81832 5.66919Z')
					path#in(transform="scale(0.8 0.8)" fill-rule='evenodd', clip-rule='evenodd', d='M6.37783 9.21709C7.69107 9.21709 8.75566 8.1525 8.75566 6.83926C8.75566 5.52602 7.69107 4.46143 6.37783 4.46143C5.06459 4.46143 4 5.52602 4 6.83926C4 8.1525 5.06459 9.21709 6.37783 9.21709ZM6.37783 13.2171C9.90021 13.2171 12.7557 10.3616 12.7557 6.83926C12.7557 3.31688 9.90021 0.461426 6.37783 0.461426C2.85545 0.461426 0 3.31688 0 6.83926C0 10.3616 2.85545 13.2171 6.37783 13.2171Z')
					path#dunk(transform="scale(0.4 0.4)" d="M0 1H7.04615L11.9385 15.6975H12.0308L16.9231 1H24V23H18.8308V10.1204H18.6769C18.4308 11.127 18.1538 12.0514 17.8462 12.8936L14.3385 23H9.69231L6.18462 12.8936C5.79487 11.7843 5.51795 10.8599 5.35385 10.1204H5.2V23H0V1Z")

					use#local-in(xlink:href='#in', :fill="local_color")
					use#local-out(xlink:href='#out', :fill="local_color")
					use#local-dunk(xlink:href='#dunk', :fill="local_color")
					use#visitor-in(xlink:href='#in', :fill="visitor_color")
					use#visitor-out(xlink:href='#out', :fill="visitor_color")
					use#visitor-dunk(xlink:href='#dunk', :fill="visitor_color")

					pattern(id="img1" patternUnits="userSpaceOnUse" x="0" y="0" width="513" height="294")
						image(xlink:href="/pista-acb.jpg" width="513" height="294")
					
				path(d="M5,5 l0,680 l980,0 l0,-680 l-980,0" fill="url(#img1)")

				transition-group(name="fade-shot" tag="g")
					use(
						v-for="(shot,index) in localShotList"
						:key="'ls'+shot.name+index"
						:xlink:href="shot.dunk ? '#local-dunk' : (shot.scored ? '#local-in' : '#local-out')"
						:x="shot.x"
						:y="shot.y"
					)
				transition-group(name="fade-shot" tag="g")
					use(
						v-for="(shot,index) in visitorShotList"
						:key="'vs'+shot.name+index"
						:xlink:href="shot.dunk ? '#visitor-dunk' : (shot.scored ? '#visitor-in' : '#visitor-out')"
						:x="shot.x"
						:y="shot.y"
					)
	.sm-table.sm-table--visitor
		.ge-head_team
			img.ge-head_team__img(:src="$store.state.match.visitorImage", :alt="$store.state.match.visitorShortName")
			span.ge-head_team__name {{ $store.state.match.visitorShortName }}
		
		.ge-btn(
			:class="isVisitorTeamSelected ? 'ge-btn' : 'ge-btn--ghost'"
			role="button"
			@click="toggleVisitorTeam"
		)
			span {{ $t('Select all') }}
		table.ta.ta--sm(v-show="!userRequestFail")
			thead.ta-section.ta-section--head
				tr.ta-row
					th.ta-col {{ $t('Num.') }}
					th.ta-col.ta-col--name {{ $t('Player') }}
					th.ta-col {{ $t('Pun') }}
			tbody.ta-section.ta-section--body
				tr.ta-row(
					role="button"
					v-for="(player, name) in shots.visitor_team"
					:id="name"
					@click="toggleVisitorPlayer(player,sel_visitor_players)"
					:class="isVisitorPlayerSelected(player) ? 'ta-row--selected' : ''"
				)
					td.ta-col 
						span {{ player.num }}
					td.ta-col.ta-col--name 
						span {{ name }}
					td.ta-col 
						span {{ player.score }}
				
</template>

<style lang="sass">

.fade-shot-enter-active, .fade-shot-leave-active
	transition: 0.5s

.fade-shot-enter, .fade-shot-leave-to
	opacity: 0

.sm
	width: 100%
	display: grid
	justify-content: center
	align-items: start
	grid-column-gap: 0.5rem
	grid-row-gap: 3rem
	padding: 4rem 1rem
		bottom: 16rem
	box-sizing: border-box
	grid-template-columns: minmax(auto,300px) minmax(auto,300px)
	grid-template-areas: "graphic graphic" "ltable vtable"
	justify-content: center

	+breakpoint(1400px)
		grid-template-columns: minmax(auto,200px) minmax(auto,650px) minmax(auto,200px)
		grid-template-areas: "ltable graphic vtable"
		grid-gap: 3rem


	&-gra
		&-wrap
			grid-area: graphic
			display: grid
			grid-auto-flow: row
			grid-row-gap: 1rem
			width: 100%

		&-fi
			width: 100%
			box-sizing: border-box
			min-height: 30px
			display: flex
			flex-wrap: wrap
			flex-direction: row
			justify-content: space-around
			& > *
				padding: 0.5rem


	&-table
		display: grid
		grid-auto-flow: row
		align-items: start
		justify-items: center
		grid-gap: 1.5rem

		width: 100%
		max-width: 200px
		justify-self: center

		&__shield
			max-height: 40px
		&--local
			grid-area: ltable

		&--visitor
			grid-area: vtable

</style>

<script>
import api from "@/api/index";
import NavQuarter from "@/components/subcomponents/nav/NavQuarter.vue";
import Loading from "@/components/subcomponents/general/Loading.vue";
import AnimatedValue from "@/components/subcomponents/general/AnimatedValue.vue";

export default {
	name: "ShootMap",
	data() {
		return {
			loaded: false,
			shots: [],
			raw_data: [],
			sel_local_players: [],
			sel_visitor_players: [],
			status: "all",
			player_scores: {},
			userRequestFail: false,
			timer: null,
			initialFail: false,
			initialTimer: null,
			local_color: "#4B4B4B",
			visitor_color: "#808080"
		};
	},
	computed: {
		refreshSignal() {
			return this.$store.state.general.refreshSignal;
		},
		localShotList() {
			return this.getShotList(this.$data.sel_local_players);
		},
		visitorShotList() {
			return this.getShotList(this.$data.sel_visitor_players);
		},
		isShowAll() {
			return this.$data.status == "all";
		},
		isShowScored() {
			return this.$data.status == "scored";
		},
		isShowMiss() {
			return this.$data.status == "miss";
		},
		isLocalTeamSelected() {
			if (this.$data.shots)
				if (this.$data.shots.local_team)
					return (
						Object.keys(this.$data.shots.local_team).length ==
						this.$data.sel_local_players.length
					);
				else return false;
			else return false;
		},
		isVisitorTeamSelected() {
			if (this.$data.shots)
				if (this.$data.shots.visitor_team)
					return (
						Object.keys(this.$data.shots.visitor_team).length ==
						this.$data.sel_visitor_players.length
					);
				else return false;
			else return false;
		},
		selPeriod() {
			return this.$store.state.match.selQuarter;
		},
		idMatch() {
			return this.$route.params.id_match;
		},
		quarterNum() {
			return this.$store.state.match.quarterNum;
		}
	},
	methods: {
		updatePeriodData(data) {
			let local = {};
			let visitor = {};
			for (let period of data) {
				for (let [name, player] of Object.entries(period.local_team)) {
					if (local[name]) {
						for (let shot of player.shots) local[name].shots.push(shot);
					} else {
						local[name] = {};
						local[name].num = player.num;
						local[name].score = this.$data.player_scores[name];
						local[name].shots = [];
						for (let shot of player.shots) {
							local[name].shots.push(shot);
						}
					}
				}
				for (let [name, player] of Object.entries(period.visitor_team)) {
					if (visitor[name]) {
						for (let shot of player.shots) visitor[name].shots.push(shot);
					} else {
						visitor[name] = {};
						visitor[name].num = player.num;
						visitor[name].score = this.$data.player_scores[name];
						visitor[name].shots = [];
						for (let shot of player.shots) {
							visitor[name].shots.push(shot);
						}
					}
				}
				this.$data.shots = { local_team: local, visitor_team: visitor };
			}
		},
		updateShots() {
			
			return api.match.getMapshot(this.idMatch, this.selPeriod).then(data => {
				this.$data.raw_data = data;
				this.updatePeriodData(this.$data.raw_data);
				this.$data.loaded = true;
				this.clearInitialTimer()
				this.clearTimer()
			});
		},
		updatePoints() {
			let params = {
				idMatch: this.$route.params.id_match,
			}
			if (this.selPeriod) {
				params['period'] = this.selPeriod
			}
			return api.match
				.getPlayersStats(params)
				.then(data => {
					let player_scores = {};
					for (let player of data.local_team) {
						player_scores[player.nombre] = +player.puntos;
					}
					for (let player of data.visiting_team) {
						player_scores[player.nombre] = +player.puntos;
					}
					
					this.$data.player_scores = player_scores;
					return this.updateShots();
				});
		},
		isLocalPlayerSelected(player) {
			return this.$data.sel_local_players.findIndex(sel => sel.num == player.num) != -1;
		},
		isVisitorPlayerSelected(player) {
			return (
				this.$data.sel_visitor_players.findIndex(sel => sel.num == player.num) != -1
			);
		},
		toggleLocalPlayer(player, player_list) {
			let position = player_list.findIndex(sel => sel.num == player.num);
			if (this.isLocalTeamSelected) {
				this.$data.sel_local_players = [player]
			}
			if (position == -1) {
				player_list.push(player);
			} else {
				player_list.splice(position, 1);
			}
		},
		toggleVisitorPlayer(player, player_list) {
			let position = player_list.findIndex(sel => sel.num == player.num);
			if (this.isVisitorTeamSelected) {
				this.$data.sel_visitor_players = [player]
			}
			if (position == -1) {
				player_list.push(player);
			} else {
				player_list.splice(position, 1);
			}
		},
		setStatus(status) {
			this.$data.status = status;
		},
		selectTeam(team) {
			if (team == "local") {
				this.$data.sel_local_players = [];
				for (let shot in this.$data.shots.local_team) {
					this.$data.sel_local_players.push(this.$data.shots.local_team[shot]);
				}
			} else {
				this.$data.sel_visitor_players = [];
				for (let shot in this.$data.shots.visitor_team) {
					this.$data.sel_visitor_players.push(
						this.$data.shots.visitor_team[shot]
					);
				}
			}
		},
		toggleLocalTeam() {
			if (!this.isLocalTeamSelected) {
				this.selectTeam("local");
			} else {
				this.$data.sel_local_players = [];
			}
		},
		toggleVisitorTeam() {
			if (!this.isVisitorTeamSelected) {
				this.selectTeam("visitor");
			} else {
				this.$data.sel_visitor_players = [];
			}
		},
		getShotList(team) {
			let shot_list = [];
			for (let player of team) {
				for (let shot of player.shots) {
					if (this.$data.status == "all") {
						shot_list.push(shot);
					} else if (this.$data.status == "scored") {
						if (shot.scored) {
							shot_list.push(shot);
						}
					} else {
						if (!shot.scored) {
							shot_list.push(shot);
						}
					}
				}
			}
			return shot_list;
		},
		setTimer() {
			this.timer = setTimeout(
				() => {
					this.$data.userRequestFail = true
				},
				this.$store.state.general.requestTimeout
			)
		},
		clearTimer() {
			if (this.timer) {
				this.$data.userRequestFail = false
				this.$data.initialFail = false
				clearTimeout(this.timer)
			}
		},
		setInitialTimer() {
			this.timer = setTimeout(
				() => {
					this.$data.initialFail = true
				},
				this.$store.state.general.requestTimeout
			)
		},
		clearInitialTimer() {
			if (this.initialTimer) {
				this.$data.initialFail = false
				clearTimeout(this.initialTimer)
			}
		},
	},
	watch: {
		selPeriod() {
			this.setTimer()
			this.updatePoints().then(() => {
				this.selectTeam("local");
				this.selectTeam("visitor");
			});
		},
		refreshSignal(newValue) {
			if (newValue) {
				if (this.$store.state.match.status == "playing" || this.$store.state.general.refreshing)
					this.updatePoints();
			}
		},
		quarterNum(newValue) {
			if (newValue && !this.$data.raw_data) {
				this.updatePoints();
			}
		}
	},
	created() {
		this.setInitialTimer()
		this.updatePoints().then(() => {
			this.selectTeam("local");
			this.selectTeam("visitor");
		});
	},
	mounted() {
		this.$parent.goTop();
	},
	components: {
		NavQuarter,
		Loading,
		AnimatedValue
	}
};
</script>
